
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class InkBleedEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spots = Math.floor(15 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < spots; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                
                const growth = (curTime * 0.2 + this.pseudoRandom(i)) % 1;
                const r = growth * 400 * scale * (1 / (layerIndex + 1));
                const alpha = (1 - growth) * 0.4;
                
                ctx.save();
                ctx.globalAlpha = alpha / (layerIndex + 1);
                ctx.beginPath();
                // Irregular bleed shape
                for (let a = 0; a < Math.PI * 2; a += 0.2) {
                    const dr = (this.pseudoRandom(Math.floor(a * 10) + i) * 50 * scale) * growth;
                    const px = Math.cos(a) * (r + dr);
                    const py = Math.sin(a) * (r + dr);
                    if (a === 0) ctx.moveTo(px, py);
                    else ctx.lineTo(px, py);
                }
                ctx.fill();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
